import React, { useState, useEffect } from "react";
import axios from "axios";
import { AuthGuard } from "../App";
import { EmailGuard } from "../App";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { StandardURL } from "../App";

const UserSettlements = () => {
  const [usersettlements, setUserSettlements] = useState([]);
  const [useryId, setUserYId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserSettlements();
  }, []);

  const fetchUserSettlements = () => {
    const token = localStorage.getItem("token");
    axios
      .get(`${StandardURL}/iNyumba/admin/settlementcheck/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setUserSettlements(response.data.response);
      })
      .catch((error) => {
        console.error("Error fetching User Settlements:", error);
        toast.error(error.response.data.response);
      });
  };

  const handleDownload = (endpoint, fileType) => {
    const token = localStorage.getItem("token");
    axios
      .get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { format: fileType },
        responseType: "blob", // Important for file download
      })
      .then((response) => {
        const fileExtension = fileType === "pdf" ? "pdf" : "csv";
        const fileName = `usersettlementreport_${new Date().toISOString()}.${fileExtension}`;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        toast.success("Download is successful");
      })
      .catch((error) => {
        console.log(error);
        console.error(`Error downloading ${fileType.toUpperCase()}:`, error);
        toast.error(error.response.data.response);
      });
  };

  const handleDownloadWithuserId = (fileType) => {
    const token = localStorage.getItem("token");

    if (!useryId) {
      toast.error("Please enter a valid User ID");
      return;
    }

    axios
      .get(
        `${StandardURL}/iNyumba/admin/settlementreport/tenantsettlement/${useryId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { format: fileType },
          responseType: "blob", // Important for file download
        }
      )
      .then((response) => {
        const fileExtension = fileType === "pdf" ? "pdf" : "csv";
        const fileName = `usersettlementreport_${new Date().toISOString()}.${fileExtension}`;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        toast.success("Download is successful");
      })
      .catch((error) => {
        console.log(error);
        console.error(`Error downloading ${fileType.toUpperCase()}:`, error);
        toast.error(error.response.data.response);
      });
  };

  const handleDelete = (settlementId) => {
    const token = localStorage.getItem("token");
    if (window.confirm("Are you sure you want to delete this settlement?")) {
      axios
        .delete(
          `${StandardURL}/iNyumba/admin/settlementcheck/deletetenantsettlement/${settlementId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          toast.success("Settlement deleted successfully");
          // Optionally, refresh the list after deletion
          setUserSettlements((prevSettlements) =>
            prevSettlements.filter(
              (settlement) => settlement.settlement_id !== settlementId
            )
          );
        })
        .catch((error) => {
          console.error("Error deleting settlement:", error);
          toast.error("Failed to delete the settlement");
        });
    }
  };

   // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = usersettlements.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(usersettlements.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

    return (
    <EmailGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
          <div className="container mx-auto max-w-7xl rounded-2xl bg-white p-8 shadow-xl">
            <h1 className="mb-6 text-3xl font-bold tracking-tight text-gray-900">
              User Settlements
            </h1>

            <div className="mb-8 flex flex-col items-center justify-between space-y-4 sm:flex-row sm:space-x-8 sm:space-y-0">
              <div className="flex space-x-2">
                <button
                  onClick={() =>
                    handleDownload(
                      "https://backend.inyumba.co.ke/iNyumba/admin/settlementreport/tenantsettlementme",
                      "csv"
                    )
                  }
                  className="inline-flex items-center rounded-md bg-green-500 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                >
                  <FontAwesomeIcon icon={faFileCsv} className="mr-2" />
                  Download All CSV
                </button>
                <button
                  onClick={() =>
                    handleDownload(
                      "https://backend.inyumba.co.ke/iNyumba/admin/settlementreport/tenantsettlementme",
                      "pdf"
                    )
                  }
                  className="inline-flex items-center rounded-md bg-red-500 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="mr-2" />
                  Download All PDF
                </button>
              </div>

              <div className="flex flex-grow items-end space-x-2">
                <div className="flex-grow">
                  <label
                    htmlFor="useryId"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Filter by User ID
                  </label>
                  <input
                    type="text"
                    id="useryId"
                    value={useryId}
                    onChange={(e) => setUserYId(e.target.value)}
                    placeholder="e.g., U001"
                    className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-gray-700 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                  />
                </div>
                <button
                  onClick={() => handleDownloadWithuserId("csv")}
                  className="inline-flex items-center rounded-md bg-green-500 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                >
                  <FontAwesomeIcon icon={faFileCsv} className="mr-2" />
                  CSV
                </button>
                <button
                  onClick={() => handleDownloadWithuserId("pdf")}
                  className="inline-flex items-center rounded-md bg-red-500 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="mr-2" />
                  PDF
                </button>
              </div>
            </div>

            <div className="overflow-x-auto rounded-lg shadow-md">
              <table className="min-w-full table-auto text-sm">
                <thead className="bg-gray-100">
                  <tr className="text-left text-xs font-semibold uppercase tracking-wider text-gray-600">
                    <th className="px-6 py-4">Settlement Id</th>
                    <th className="px-6 py-4">User ID</th>
                    <th className="px-6 py-4">Total Amount Paid</th>
                    <th className="px-6 py-4">Transaction Cost</th>
                    <th className="px-6 py-4">Our Reference</th>
                    <th className="px-6 py-4">Transaction Reference</th>
                    <th className="px-6 py-4">Status</th>
                    <th className="px-6 py-4">OTP</th>
                    <th className="px-6 py-4">Attempts</th>
                    <th className="px-6 py-4">Created On</th>
                    <th className="px-6 py-4 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {currentItems.map((settlement) => (
                    <tr
                      key={settlement.settlement_id}
                      className="transition-colors duration-200 hover:bg-sky-50"
                    >
                      <td className="whitespace-nowrap px-6 py-4 font-medium text-gray-900">
                        {settlement.settlement_id}
                      </td>
                      <td className="whitespace-nowrap px-6 py-4 text-gray-700">
                        {settlement.user_id}
                      </td>
                      <td className="whitespace-nowrap px-6 py-4 text-gray-700">
                        ${settlement.total_amount_paid}
                      </td>
                      <td className="whitespace-nowrap px-6 py-4 text-gray-700">
                        ${settlement.transactioncost}
                      </td>
                      <td className="whitespace-nowrap px-6 py-4 text-gray-700">
                        {settlement.reference}
                      </td>
                      <td className="whitespace-nowrap px-6 py-4 text-gray-700">
                        {settlement.paymentreference}
                      </td>
                      <td className="whitespace-nowrap px-6 py-4">
                        <span className={`inline-flex rounded-full px-2 text-xs font-semibold leading-5 ${
                          settlement.status === "Completed"
                            ? "bg-green-100 text-green-800"
                            : settlement.status === "Pending"
                            ? "bg-yellow-100 text-yellow-800"
                            : "bg-red-100 text-red-800"
                        }`}>
                          {settlement.status}
                        </span>
                      </td>
                      <td className="whitespace-nowrap px-6 py-4 text-gray-700">
                        {settlement.otp}
                      </td>
                      <td className="whitespace-nowrap px-6 py-4 text-gray-700">
                        {settlement.attempts}
                      </td>
                      <td className="whitespace-nowrap px-6 py-4 text-gray-700">
                        {new Date(settlement.created_at).toLocaleString()}
                      </td>
                      <td className="whitespace-nowrap px-6 py-4 text-center">
                        <button
                          onClick={() => handleDelete(settlement.settlement_id)}
                          className="transform rounded-full bg-red-500 px-4 py-2 text-xs font-semibold text-white shadow-sm transition-all duration-200 hover:scale-105 hover:bg-red-600"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="mt-8 flex items-center justify-between">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="rounded-md bg-gray-200 px-4 py-2 text-sm font-semibold text-gray-700 transition-colors duration-200 hover:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  Previous
                </button>
                <div className="flex space-x-1">
                  {Array.from({ length: totalPages }, (_, i) => (
                    <button
                      key={i + 1}
                      onClick={() => handlePageChange(i + 1)}
                      className={`rounded-md px-4 py-2 text-sm font-semibold ${
                        currentPage === i + 1
                          ? "bg-blue-600 text-white"
                          : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                      }`}
                    >
                      {i + 1}
                    </button>
                  ))}
                </div>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="rounded-md bg-gray-200 px-4 py-2 text-sm font-semibold text-gray-700 transition-colors duration-200 hover:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
      </AuthGuard>
    </EmailGuard>
  );
};



export default UserSettlements;
